import React from "react";

import PropTypes from "prop-types";

import { Table as AntTable } from "antd";

const Summary = ({
    summary,
    columns,
    isTableExpandable
}) => {

    const { title, data } = summary;

    const renderColumnContent = (column, index) => {
        if(index === 0 && !isTableExpandable){
            return title;
        }

        if(column.fixed === "left"){
            return null;
        }

        if(data[column.dataIndex]){
            return <span className='rt--font-bold'>{data[column.dataIndex]}</span>
        }

        return null;
    }

    const fixedLeftColumnsLength = columns.filter(c => c.fixed === "left").length;

    return (
        <AntTable.Summary fixed="bottom">
            <AntTable.Summary.Row>
                {
                    isTableExpandable && (
                        <AntTable.Summary.Cell index={0} colSpan={fixedLeftColumnsLength + 1}>
                            {
                                <span className='rt--font-bold'>{title}</span>
                            }
                        </AntTable.Summary.Cell>
                    )
                }
                {
                    columns.map((column, index) => {
                        if( (index !== 0 || isTableExpandable) && column.fixed === "left"){
                            return null;
                        }
                        return (
                            <AntTable.Summary.Cell
                                key={column.dataIndex}
                                index={isTableExpandable ? index + 1 : index}
                                colSpan={index === 0 && !isTableExpandable && fixedLeftColumnsLength > 0 ? fixedLeftColumnsLength : undefined}
                            >
                                {renderColumnContent(column, index)}
                            </AntTable.Summary.Cell>
                        )
                    })
                }
            </AntTable.Summary.Row>
        </AntTable.Summary>
    )
}

Summary.propTypes = {
    summary: PropTypes.object,
}

export default Summary;